module.exports = __webpack_public_path__ + "f571fd6ebfccdf484262a9c556c2a2e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/favicon-32.png
// module id = 499
// module chunks = 0